import { useState, useCallback, useEffect } from "react";
import { IUser } from "src/domains";
import { queryGetUser } from "src/graphql";
import { useAuth, AuthState } from "src/hooks/cognito";

export const useUser = (id?: string) => {
  const auth = useAuth();
  const [user, setUser] = useState<IUser | undefined>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | undefined>();
  let _isMount = true;

  const refresh = useCallback(
    async (localId?: string) => {
      if (!localId || !_isMount) {
        return;
      }
      if (_isMount) {
        setLoading(true);
      }
      try {
        const response = await queryGetUser(
          { id: localId },
          auth === AuthState.Auth ? "AMAZON_COGNITO_USER_POOLS" : "API_KEY"
        );
        if (_isMount) {
          setUser(response.data.getUser);
        }
      } catch (e) {
        console.error(e);
        if (_isMount) {
          setError(e as Error);
        }
      }
      if (_isMount) {
        setLoading(false);
      }
    },
    [auth]
  );

  useEffect(() => {
    refresh(id);
  }, [refresh, id]);

  useEffect(() => {
    _isMount = true;
    return () => {
      _isMount = false;
    };
  }, []);

  return [user, loading, error, refresh] as const;
};
